import { render, staticRenderFns } from "./TReports.vue?vue&type=template&id=05de18a1&"
import script from "./TReports.vue?vue&type=script&lang=js&"
export * from "./TReports.vue?vue&type=script&lang=js&"
import style0 from "./TReports.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports